import React, { useCallback, useEffect, useState } from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Card, CardHeader, CardContent, Tabs, Tab, Grid, Box, Table, TableRow, TableCell, TablePagination, InputLabel, Select, MenuItem, Snackbar, Backdrop, CircularProgress, Alert } from "@mui/material";
import colors from "assets/theme/base/colors";
// API
import { fetchDriversPayout, updateDriverPayoutStatus, getDriverStatus, fetchDriversSettlement } from "features/drivers/services/driversService";
const DriverSettlement = () => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [filterStatus, setFilterStatus] = useState("all");
    const [data, setData] = useState([]);
    const [showStatus, setShowStatus] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);




    const fetchDriverPayout = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetchDriversSettlement({
                status: filterStatus,
            });
            console.log("response", response)
            setData(response?.data?.items)
        } catch (error) {
            setError("Failed to fetch driver payouts. Please try again.");
        } finally {
            setLoading(false);
        }
    }, [filterStatus]); // <-- re-fetch when filter or page changes

    const showStatusArray = async () => {
        try {
            const response = await getDriverStatus();
            if (response.success) {
                const data = response?.data ?? response;
                if (data) setShowStatus(data);
            }
        } catch (error) {
            setError("Failed to fetch driver. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleStatusChange = async (id, newStatus) => {
        try {
            const response = await updateDriverPayoutStatus({ id, status: newStatus });

            if (response.success) {
                setSuccess(response.message || "Status updated successfully.");

            } else {
                console.warn("⚠️ API responded but not successful:", response.data);
            }
        } catch (error) {
            console.error("❌ Error updating status:", error);
        }
        setData((prev) =>
            prev.map((p) => (p.id === id ? { ...p, status: newStatus } : p))
        );
    };
    const handleChangePage = (event, newPage) => setPage(newPage);

    const handleTabChange = (event, newValue) => {
        setFilterStatus(newValue);
    };

    // Fallback statuses if API data is empty
    const statuses =
        showStatus.length > 0
            ? ["All", ...showStatus]
            : ["All", "Pending", "Processing", "Paid", "Failed", "Completed", "Reversed", "Cancelled"];


    useEffect(() => {
        showStatusArray();
        fetchDriverPayout();
    }, [fetchDriverPayout, page, filterStatus]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Grid item xs={12} md={8} mt={3}>
                <Card sx={{ borderRadius: 3, boxShadow: "0 3px 10px rgba(0,0,0,0.1)" }}>
                    <CardHeader title="Driver Settlement System" />

                    <CardContent>

                        <Box
                            sx={{
                                mb: 3,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: 2,
                            }}
                        >
                            <Tabs
                                value={filterStatus}
                                onChange={handleTabChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{
                                    "& .MuiTab-root": {
                                        textTransform: "none",
                                        borderRadius: 2,
                                        mx: 0.5,
                                        px: 2,
                                        py: 1,
                                        minHeight: "auto",
                                    },
                                    "& .Mui-selected": {
                                        backgroundColor: colors.gradients.info.main,
                                        color: "#fff !important",
                                    },
                                }}
                            >
                                {statuses.map((status, index) => (
                                    <Tab
                                        key={index}
                                        label={status.charAt(0).toUpperCase() + status.slice(1)}
                                        value={status.toLowerCase()}
                                    />
                                ))}
                            </Tabs>
                        </Box>


                        {/* Payout Table */}
                        <Table sx={{ minWidth: 650 }}>
                            {/* Table Header */}
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                                <TableCell sx={{ fontWeight: 600, textAlign: "right" }}>Amount (QAR)</TableCell>
                                <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Payment Method</TableCell>
                                <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>Status</TableCell>
                            </TableRow>

                            {/* Table Body */}
                            {data
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((payout) => (
                                    <TableRow
                                        key={payout.id}
                                        hover
                                        sx={{
                                            "&:last-child td, &:last-child th": { border: 0 },
                                            "&:hover": { backgroundColor: "#f9fafb" },
                                        }}
                                    >
                                        {/* ✅ Date */}
                                        <TableCell sx={{ textAlign: "left", py: 1.5 }}>
                                            {new Date(payout.createdAt).toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                                hour12: false, // 24-hour format
                                            })}
                                        </TableCell>

                                        {/* ✅ Amount */}
                                        <TableCell sx={{ textAlign: "right", py: 1.5 }}>
                                            QAR {payout.amount}
                                        </TableCell>

                                        {/* ✅ Payment Method */}
                                        <TableCell sx={{ textAlign: "center", py: 1.5 }}>
                                            {payout.method || "N/A"}
                                        </TableCell>

                                        {/* ✅ Status */}
                                        <TableCell sx={{ textAlign: "center", py: 1.5 }}>
                                            {payout.status?.toLowerCase() === "completed" ? (
                                                <Box
                                                    sx={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        minWidth: 130,
                                                        height: 36,
                                                        px: 2,
                                                        borderRadius: 2,
                                                        backgroundColor: "#cfe2ff",
                                                        fontWeight: 500,
                                                        textTransform: "capitalize",
                                                        fontSize: "0.875rem",
                                                        color: "#000",
                                                    }}
                                                >
                                                    {payout.status}
                                                </Box>
                                            ) : (
                                                <Select
                                                    value={payout.status}
                                                    onChange={(e) => handleStatusChange(payout.id, e.target.value)}
                                                    size="small"
                                                    sx={{
                                                        minWidth: 130,
                                                        borderRadius: 2,
                                                        backgroundColor: (() => {
                                                            const status = payout.status?.toLowerCase();
                                                            switch (status) {
                                                                case "paid":
                                                                    return "#d4edda";
                                                                case "processing":
                                                                    return "#fff3cd";
                                                                case "failed":
                                                                    return "#f8d7da";
                                                                case "completed":
                                                                    return "#cfe2ff";
                                                                case "reversed":
                                                                    return "#fbeaea";
                                                                case "cancelled":
                                                                    return "#ffcccc";
                                                                case "pending":
                                                                    return "#e2e3e5";
                                                                default:
                                                                    return "#fff";
                                                            }
                                                        })(),
                                                        "& .MuiSelect-select": {
                                                            textAlign: "center",
                                                            fontWeight: 200,
                                                            textTransform: "capitalize",
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="pending">Pending</MenuItem>
                                                    <MenuItem value="processing">Processing</MenuItem>
                                                    <MenuItem value="paid">Paid</MenuItem>
                                                    <MenuItem value="failed">Failed</MenuItem>
                                                    <MenuItem value="completed">Completed</MenuItem>
                                                    <MenuItem value="reversed">Reversed</MenuItem>
                                                    <MenuItem value="cancelled">Cancelled</MenuItem>
                                                </Select>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </Table>


                        {/* Pagination */}
                        <TablePagination
                            component="div"
                            count={data.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </CardContent>
                </Card>
            </Grid>
            <Footer />
            <Snackbar
                open={!!error || !!success}
                autoHideDuration={3000}
                onClose={() => { setError(null); setSuccess(null); }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={() => { setError(null); setSuccess(null); }} severity={error ? "error" : "success"} sx={{ width: '100%' }}>
                    {error || success}
                </Alert>
            </Snackbar>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </DashboardLayout>

    )
}

export default DriverSettlement
